import React from "react";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import { useStyle } from "../style";

const WHDamageModal = ({ tableHeadData, flattenedData, setOpen, data }) => {
  const classes = useStyle();

  return (
    <Grid sx={{ backgroundColor: "#fff", padding: "10px", maxHeight: "500px", overflowY: "auto" }}>
      <div className="flex justify-between">
        {data && (
          <Grid className="flex my-1" style={{ flexDirection: "column" }}>
            <Typography>Date: <strong>{data.documentDate}</strong></Typography>
          </Grid>
        )}
        <IconButton size="small" sx={{ marginBlockEnd: 2 }} onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </div>
      <TableContainer className={classes.tblRoot}>
        <Table className={classes.table}>
          <TableHead className={classes.tblHeader} sx={{ backgroundColor: "black", color: "#fff" }}>
            <TableRow className={classes.tablrow} sx={{ color: "#fff" }}>
              {tableHeadData.map((item) => (
                <TableCell className={classes.tblCell} sx={{ color: "#fff" }} key={item.id}>{item.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {flattenedData.map((val) => (
              <TableRow className={classes.tablrow} key={val.id}>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.sNo}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.docno}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{moment(val.date).format("DD-MM-YYYY")}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.proName}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.barcode}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.amount}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.rate}</TableCell>
                <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.qty}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default WHDamageModal;
